export default __webpack_public_path__ + "static/media/catering1.1df070e8.jpg";